import React from 'react'
import { CFormSelect } from '@coreui/react'
import Select from 'react-select'

const CustomerInfoSection = ({
  inputList,
  customer, // Xero contact options: [{ value: ContactID, label, raw }]
  customerSelectOptions, // selected Xero contact option
  customerAddress, // addresses from your local customer
  addressSelect, // full Xero contact object for phones table
  errorList,
  onCustomerChange, // (option|null) => void
  onAddressChange, // (e) => void
  onFieldChange, // (e) => void
  customersLoading, // boolean
}) => {
  // Map Xero phones to fixed columns
  const phones = addressSelect?.Phones || []
  const getPhone = (type) =>
    phones.find((p) => p.PhoneType?.toUpperCase() === type)?.PhoneNumber || '-'

  return (
    <>
      <h5>Customer Information</h5>

      <div className="row">
        {/* Customer Code (Xero Contacts) */}
        <div className="col-lg-6 mb-3">
          <label className="pb-2">
            Customer Code <span className="text-danger">*</span>
          </label>
          <Select
            name="customer_id"
            value={customerSelectOptions}
            options={customer}
            onChange={onCustomerChange}
            placeholder={customersLoading ? 'Loading Xero customers…' : 'Select Customer…'}
            getOptionLabel={(opt) => opt.label}
            getOptionValue={(opt) => String(opt.value)}
            isLoading={customersLoading}
            isDisabled={customersLoading}
            isClearable
            noOptionsMessage={() => (customersLoading ? 'Loading…' : 'No customers found')}
          />
          <span className="text-danger">{errorList['customer_id']}</span>
        </div>

        {/* Account Name */}
        <div className="col-lg-3 mb-3">
          <label className="pb-2">Account Name</label>
          <input
            type="text"
            name="account_name"
            className="form-control"
            value={inputList.account_name}
            disabled
            readOnly
          />
        </div>

        {console.log('accountname', inputList)}

        {/* Account Contact Name */}
        <div className="col-lg-3 mb-3">
          <label className="pb-2">Account Contact Name</label>
          <input
            type="text"
            name="account_contact_name"
            className="form-control"
            value={inputList.account_contact_name}
            disabled
            readOnly
          />
        </div>

        {/* Address (from your local customer once linked) */}
        <div className="col-lg-6 mb-4">
          <label className="pb-2">Address</label>
          <CFormSelect
            name="customer_address"
            value={inputList.customer_address}
            onChange={onAddressChange}
            disabled={!inputList.customer_id} // enabled only when local customer is resolved
          >
            <option value="">-- select --</option>
            {customerAddress.map((addr) => (
              <option key={addr.id} value={addr.id}>
                {addr.address}
              </option>
            ))}
          </CFormSelect>
          <span className="text-danger">{errorList['customer_address']}</span>
        </div>

        {/* Phones (from selected Xero contact) */}
        <div className="col-lg-6 mb-3">
          <table className="table table-bordered mb-0">
            <thead>
              <tr>
                <th>DDI</th>
                <th>Default</th>
                <th>Fax</th>
                <th>Mobile</th>
              </tr>
            </thead>
            <tbody>
              {phones.length ? (
                <tr>
                  <td>{getPhone('DDI')}</td>
                  <td>{getPhone('DEFAULT')}</td>
                  <td>{getPhone('FAX')}</td>
                  <td>{getPhone('MOBILE')}</td>
                </tr>
              ) : (
                <tr>
                  <td colSpan="4">Please select a customer (and address if required)</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Terms */}
        <div className="col-lg-3 mb-3">
          <label className="pb-2">Terms</label>
          <input
            type="text"
            name="customer_terms_name"
            className={
              inputList.customer_terms_highlight === '0'
                ? 'form-control bg-danger text-white'
                : 'form-control'
            }
            value={inputList.customer_terms_name}
            onChange={onFieldChange}
            disabled
            readOnly
          />
          <span className="text-danger">{errorList['terms']}</span>
        </div>

        {/* Quoted Price */}
        <div className="col-lg-3 mb-3">
          <label className="pb-2">Quoted Price</label>
          <input
            type="text"
            name="quoted_price"
            className="form-control"
            value={inputList.quoted_price}
            onChange={onFieldChange}
          />
          <span className="text-danger">{errorList['quoted_price']}</span>
        </div>

        {/* Customer Reference */}
        <div className="col-lg-4 mb-3">
          <label className="pb-2">Customer Reference</label>
          <input
            type="text"
            name="customer_reference"
            className="form-control"
            value={inputList.customer_reference}
            onChange={onFieldChange}
          />
          <span className="text-danger">{errorList['customer_reference']}</span>
        </div>

        {/* Driver Notes */}
        <div className="col-lg-12 mb-3">
          <label className="pb-2">Driver Notes</label>
          <textarea
            name="driver_note"
            className="form-control"
            rows={3}
            value={inputList.driver_note}
            onChange={onFieldChange}
          />
          <span className="text-danger">{errorList['driver_note']}</span>
        </div>

        {/* Admin Notes */}
        <div className="col-lg-12 mb-3">
          <label className="pb-2">Admin Notes</label>
          <textarea
            name="admin_note"
            className="form-control"
            rows={3}
            value={inputList.admin_note}
            onChange={onFieldChange}
          />
          <span className="text-danger">{errorList['admin_note']}</span>
        </div>
      </div>
    </>
  )
}

export default CustomerInfoSection
